/**
 * Formats a number as a currency string
 * @param value - The value to format
 * @param currency - The currency code (default: USD)
 * @returns Formatted currency string
 */
export const formatCurrency = (value: number, currency = 'USD'): string => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};

/**
 * Formats a number as a percentage string
 * @param value - The percentage value (0.5 = 50%)
 * @param fractionDigits - Number of fraction digits to display
 * @returns Formatted percentage string
 */
export const formatPercentage = (value: number, fractionDigits = 2): string => {
    return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    }).format(value / 100);
};
